var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRingdna(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    width: 100,
    height: 58,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 413.1 90",
    style: {
      enableBackground: "new 0 0 413.1 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#0062FF;}\r\n\t.st1{fill:#003A7F;}\r\n\t.st2{fill:#80B4FF;}\r\n\t.st3{fill:#CBC0FF;}\r\n\t.st4{fill:#33CC99;}\r\n\t.st5{fill:#7549EA;}\r\n\t.st6{fill:#FF4545;}\r\n\t.st7{fill:#FF9933;}\r\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M118.3,24.9c-0.9-0.1-2.1-0.2-3.2-0.2c-7.2,0-12.3,5.7-12.4,14v26.8h-8.6V18.1h5.8c0.9,1.7,1.5,4,2.1,6.5 c3.3-5.1,8.6-7.7,14.1-7.7c1.1,0,1.9,0.1,2.6,0.2L118.3,24.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M144.4,65.5h-8.6v-40c-3.4-0.3-6.1-0.8-8.6-1.8v-5.6h17.2V65.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M187,38.9c0-9.4-4.1-14.5-11.3-14.5c-7.5,0-12.2,6.3-12.2,14.6v26.5h-8.6V18.1h5.8c0.9,1.7,1.5,4.1,2,6.7 c3.4-5.2,8.8-8,14.8-8c12,0,18.1,8.9,18.1,20.9v27.9H187V38.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M219.8,59.1h8.8c12.9,0,19.4,6.4,19.4,15.1c0,8.5-6.5,15.2-19.3,15.2h-8.8c-12.9,0-19.4-6.4-19.4-15.1 C200.6,65.8,207.1,59.1,219.8,59.1z M224.7,16.7c7.8,0,15.2,0.5,23.5,1.4v5.7h-12c2.8,2.6,4.8,6.3,4.8,11 c0,10.3-8.1,18.4-18.9,18.4c-11.2,0-18.7-7.6-18.7-18.2C203.5,25.3,210.5,16.7,224.7,16.7z M220.3,66.3c-7.4,0-11.5,3-11.5,8 c0,4.7,3.8,8,11.5,8h8c7.4,0,11.5-3,11.5-8c0-4.7-3.8-8-11.5-8H220.3z M222.2,46.1c6.3,0,11.1-4.7,11.1-11 c0-6.4-4.8-11.1-11.1-11.1s-11.1,4.8-11.1,11.1C211.1,41.4,215.9,46.1,222.2,46.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M255.8,0.8c5.3-0.1,12-0.3,17.6-0.3c17.1,0,28.1,9.3,28.1,29.9v5.2c0,19.1-10.4,30.2-27.9,30.2 c-7.1,0-13.1,0-17.8-0.3V0.8z M292.4,30.8c0-14.6-7.2-22.1-18.8-22.1h-8.8v49h8.8c11.6,0,18.8-7.7,18.8-22V30.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M319.5,20.8c-1.1-1.6-1.8-3.9-2.2-5.7h-0.1c0.2,1.8,0.4,3.9,0.4,5.8v44.6H309V0.8h8.8l26.1,44.6 c1,1.6,1.8,3.8,2.2,5.7h0.1c-0.2-1.9-0.3-4.1-0.3-6V0.8h8.5v64.7h-8.7L319.5,20.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M381.2,0.8h9.2l17.9,52.5c1.5,4.6,1.7,7.5,1.7,12.2h-7L398.3,51h-25.1l-4.7,14.5h-7c0-4.1,0.2-7.4,1.8-12.1 L381.2,0.8z M386.9,16.1c-0.6-1.7-0.9-3.4-1.1-5.1h-0.1c-0.3,1.7-0.7,3.4-1.2,5.2l-9,27.5H396L386.9,16.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.9,5.4c0,2.5-2.1,4.6-4.6,4.6S7.7,7.9,7.7,5.4s2.1-4.6,4.6-4.6C14.8,0.8,16.9,2.9,16.9,5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.9,5.4c0,2.5-2.1,4.6-4.6,4.6S7.7,7.9,7.7,5.4s2.1-4.6,4.6-4.6C14.8,0.8,16.9,2.9,16.9,5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M62.9,5.4c0,2.5-2.1,4.6-4.6,4.6s-4.6-2.1-4.6-4.6s2.1-4.6,4.6-4.6C60.8,0.8,62.9,2.9,62.9,5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M58.1,23.9c0,2.5-2.1,4.6-4.6,4.6s-4.6-2.1-4.6-4.6s2.1-4.6,4.6-4.6S58.1,21.3,58.1,23.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M71.9,23.9c0,2.5-2.1,4.6-4.6,4.6s-4.6-2.1-4.6-4.6s2.1-4.6,4.6-4.6S71.9,21.3,71.9,23.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49,5.4c0,2.5-2.1,4.6-4.6,4.6H26c-2.5,0-4.6-2.1-4.6-4.6l0,0c0-2.5,2.1-4.6,4.6-4.6h18.4 C47,0.8,49,2.9,49,5.4L49,5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M44.3,23.9c0,2.5-2.1,4.6-4.6,4.6H21.4c-2.5,0-4.6-2.1-4.6-4.6l0,0c0-2.5,2.1-4.6,4.6-4.6h18.3 C42.3,19.3,44.3,21.3,44.3,23.9L44.3,23.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M44.3,42.3c0,2.5-2.1,4.6-4.6,4.6s-4.6-2.1-4.6-4.6s2.1-4.6,4.6-4.6C42.3,37.7,44.3,39.8,44.3,42.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21.5,60.8c0,2.5-2.1,4.6-4.6,4.6s-4.6-2.1-4.6-4.6s2.1-4.6,4.6-4.6C19.4,56.2,21.5,58.3,21.5,60.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M30.5,42.3c0,2.5-2.1,4.6-4.6,4.6H7.6c-2.5,0-4.6-2.1-4.6-4.6l0,0c0-2.5,2.1-4.6,4.6-4.6h18.3 C28.4,37.7,30.5,39.8,30.5,42.3L30.5,42.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.5,60.9c0,2.5-2.1,4.6-4.6,4.6H30.7c-2.5,0-4.6-2.1-4.6-4.6l0,0c0-2.5,2.1-4.6,4.6-4.6h18.2 C51.5,56.3,53.5,58.3,53.5,60.9L53.5,60.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRingdna);
export default __webpack_public_path__ + "static/media/ringdna.85efbf674a400ae0fba07dd7d3f8c6e4.svg";
export { ForwardRef as ReactComponent };